export const serviceOptions = ["Our Services", "Pricing", "Contact Sales", "Previous Menu"];

export const getInTouch_Options = ["Schedule a Call", "Connect via Whatsapp", "Previous Menu"];

export const supportAutomationOptions = [" Technical Issues", "Unable to access dashboard", "Billing Questions", "Other", "Previous Menu"];

export const serviceQuestionOptions = [
  "Website Design",
  "SEO",
  "Social Media Ads",
  "CRM Setup",
  "AI Automation",
  "Something else",
  "Previous Menu",
];

export const supportOptions = ["Email Us", "Contact Us", "Whatsapp", "FAQ", "Main Menu"];

export const scheduleCallOptions = [
  "Schedule a Call",
  "Connect via Whatsapp",
  "Contact Support",
  "Previous Menu",
];

export const mainOptions = [
  "Interested in Services",
  "What is Crea8 Impact?",
  "Need Support",
  "Book a strategy call",
];

export const formData = {
  firstName: "",
  email: "",
  phone: "",
  service: "",
};


function Submit() {
    const data = {
      firstName: formData.firstName || "",
      email: formData.email || "",
      phone: formData.phone || "",
    };

    fetch(
      "https://script.google.com/macros/s/AKfycbzuSf-lMpXdwIKNoXTmf3SGJy7GnRfC2ErugTCpvOm6xXSTEPihDmfIehBoDrHnifnT/exec",
      {
        method: "POST",
        redirect: "follow",
        mode: "no-cors", 
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify(data),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }


export const Flow = {
  // Initial state of the chatbot
  // This is the first message that the chatbot will send to the user

  start: {
    message:
      "Hey there, human! I'm Code8 your no-fluff digital growth sidekick. \n Here to fix a leaky funnel? Outrank your Google competition? " +
      "Or just done wasting money on strategies that don't deliver? \n 🛠 I've got tools. \n📊 I've got data.  \n And yes, I absolutely do free audits. Let's make your digital strategy less “meh” and way more “explosive!”." +
      "\n Click below to start your free lead audit or just ask me anything.",
    transition: { duration: 1000 },
    path: "show_main_options",
  },

  // **********************************************************************
  // ************************* Main Options ****************************
  // **********************************************************************
  // This is the main options that the chatbot will show to the user
  // The user can select one of the options to proceed

  show_main_options: {
    message: "Please select an option that best describes your needs:",
    chatDisabled: true,
    options: mainOptions,
    path: "process_main_options",
  },

  process_main_options: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      switch (params.userInput) {
        case "Interested in Services":
          return "show_service_options";

        case "What is Crea8 Impact?":
          await params.injectMessage(
            "Crea8 Impact is your one-stop digital transformation partner!" +
              "🚀 Our expert team empowers businesses with cutting-edge SEO, stunning website design, strategic social media marketing, and data-driven analytics." +
              " We don't just boost your brand visibility, we create measurable impact that drives real business growth. Ready to transform your digital presence?"
          );
          return "show_resource_options";

        case "Need Support":
          return "show_support_automation";

        case "Book a strategy call":
          return "get_in_touch";
        default:
          return "unknown_input";
      }
    },
  },

  // **********************************************************************
  // ************************* Service Options ****************************
  // **********************************************************************
  // This is the service options that the chatbot will show to the user
  // The user can select one of the options to proceed

  show_service_options: {
    message: "Here are our service-related options:",
    chatDisabled: true,
    options: serviceOptions,
    path: "process_service_options",
  },

  process_service_options: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      let link = "";
      switch (params.userInput) {
        case "Our Services":
          return "show_serviceQuestion_options";

        case "Pricing":
          await params.injectMessage(
            "We will be needing a litle more information."
          );
          return "get_name";

        case "Contact Sales":
          await params.injectMessage(
            "Please select how would you like to connect with us."
          );
          return "show_support_options";

        case "Previous Menu":
          return "show_main_options"

        default:
          return "unknown_input";
      }
      await params.injectMessage("Sit tight! I'll send you right there!");
      setTimeout(() => {
        window.open(link);
      }, 1000);
      return "repeat";
    },
  },

  show_serviceQuestion_options: {
    message: "What service are you most interested in?",
    options: serviceQuestionOptions,
    chatDisabled: true,
    path: "process_serviceQuestion_options",
  },

  process_serviceQuestion_options: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      switch (params.userInput) {
        case "Website Design":
          await params.injectMessage(
            "Yes, we do! We create custom websites that are not only visually impressive but built to perform. Everything is mobile-friendly and designed to give your visitors a smooth, intuitive experience." +
              " Whether you’re starting from scratch or just need a fresh new look, we’ve got you covered. If you're thinking about a new site or even just a refresh, I’d be happy to show you what we can do."
          );
          break;

        case "SEO":
          await params.injectMessage(
            "Sure thing! Our SEO services are all about helping your site rank higher on Google so the right people can find you." +
              " We take care of everything from optimizing your website content and structure to building strong backlinks and getting your local SEO spot on. If you’d like, I can set you up with a free audit to see where things stand."
          );
          break;

        case "Social Media Ads":
          await params.injectMessage(
            "Yes, we do. We create targeted ad campaigns on platforms like Facebook, Instagram, LinkedIn, and more.  " +
              "From writing the copy to designing the visuals and managing the budget, we handle it all. Our goal is always to bring in results that make a difference for your business."
          );
          break;
        case "CRM Setup":
          await params.injectMessage(
            "Definitely. We help choose the right CRM for your needs, get everything set up properly, and even customize it to fit the way your team works. " +
              "Whether you're starting from scratch or switching platforms, we’ll make sure your data is clean and your workflows are smooth."
          );
          break;
        case "AI Automation":
          await params.injectMessage(
            "We do, yes. If you're looking to streamline repetitive tasks or set up smarter workflows, we can help with that. Think automated follow-ups, " +
              "lead tracking, chatbots, and more. It’s all about helping your business run more efficiently so you can focus on the big stuff."
          );
          break;
        case "Something else":
          await params.injectMessage(
            "No problem at all. We offer a pretty wide range of services, so even if it’s not listed here, there’s a good chance we can help. " +
              "Let’s connect and go over what you’re looking for, and I’ll make sure our team gets back to you with the right info"
          );

        case "Previous Menu":
          return "show_service_options";
      }

      return "get_in_touch";
    },
  },

  get_in_touch: {
    message: "Get in touch with us:",
    options: getInTouch_Options,
    chatDisabled: true,
    path: "process_get_in_touch",
  },

   process_get_in_touch: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      let link = "";
      switch (params.userInput) {
        case "Schedule a Call":
          link = "https://calendly.com/crea8impact/30min";
          break;

        case "Connect via Whatsapp":
          link = "https://wa.me/919884645176";
          break;

        case "Contact Support":
          await params.injectMessage(
            "Please select how would you like to connect with us."
          );
          return "show_support_options";

        case "Main Menu":
          return "show_main_options";

        case "Previous Menu":
          return "show_serviceQuestion_options";

        default:
          return "unknown_input";
      }
      await params.injectMessage("Please wait while I redirect you...");
      await params.injectMessage(
        "Incase the link is blocked by your browser, try switching off your vpn or adblocker." +
          "You can directly reach us at info@crea8impact.com or whatsapp us at +919884645176"
      );
      setTimeout(() => {
        window.open(link);
      }, 1000);
      return "repeat";
    },
  },

  // **********************************************************************
  // ************************* Get Name, email and phone ******************
  // **********************************************************************
  // This is the get name, email and phone options that the chatbot will show to the user

  get_name: {
    message: "Please provide your business name:",
    function: (params) => { formData.firstName = params.userInput; },
    path: "get_email",
  },

  get_email: {
    message: "Please provide your email address:",
    function: (params) => { formData.email = params.userInput; },

    path: async (params) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(params.userInput)) {
        await params.injectMessage("Please provide a valid email address!");
        return;
      }
      return "get_phone";
    },
  },

  get_phone: {
    message: "Please provide your phone number:",
    function: (params) => { formData.phone = params.userInput; },
    
    path: async (params) => {
				if (isNaN(Number(params.userInput))) {
					await params.injectMessage("Please provide a valid phone number!");
					return;
				}
				return "submit_form";
			}
  },

  submit_form: {
    message: "Thank you for providing your details! We will get back to you shortly.",
    transition: { duration: 0 },
    chatDisabled: true,
    function: (params) => {
      // Call the submit_form function with the current form data
      Submit();
    },
    path: "repeat",
  },

    

  // **********************************************************************
  // ************************* Resource Options ****************************
  // **********************************************************************
  // This is the resource options that the chatbot will show to the user

  show_resource_options: {
    message: "Are you looking for free guides or case studies?",
    options: ["Yes", "No", "Contact Us", "Previous Menu"],
    chatDisabled: true,
    path: "process_resources",
  },

  process_resources: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      switch (params.userInput) {
        case "Yes":
          return "show_resource_page";
        case "No":
          return "show_audit_options";

        case "Contact Us":
          await params.injectMessage(
            "Please select how would you like to connect with us."
          );
          return "show_support_options";

        case "Previous Menu":
          return "show_main_options";

        default:
          return "unknown_input";
      }
    },
  },

  show_resource_page: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      let link = "/resources";
      await params.injectMessage(
        "Please wait while I redirect you to our resources page."
      );
      await params.injectMessage(
        "Incase the link is blocked by your browser, try switching off your vpn or adblocker." +
          "You can directly reach us at info@crea8impact.com or whatsapp us at +919884645176"
      );
      setTimeout(() => {
        window.open(link);
      }, 1000);
      return "repeat";
    },
  },

  show_audit_options: {
    message:
      "Would you like a free audit of your business or a free consultation?",
    options: ["Yes", "No", "Previous Menu"],
    chatDisabled: true,
    path: "process_audit_options",
  },

  process_audit_options: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      switch (params.userInput) {
        case "Yes":
          return "book_appointment";
        case "No":
          return "show_support_question";
        case "Previous Menu":
          return "show_resource_options";
      }
    },
  },

  book_appointment: {
    message: "Please select how you would like to book an appointment:",
    options: scheduleCallOptions,
    chatDisabled: true,
    path: "process_book_appointment",
  },

  process_book_appointment: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      let link = "";
      switch (params.userInput) {
        case "Schedule a Call":
          link = "https://calendly.com/crea8impact/30min";
          break;

        case "Connect via Whatsapp":
          link = "https://wa.me/919884645176";
          break;

        case "Contact Support":
          await params.injectMessage(
            "Please select how would you like to connect with us."
          );
          return "show_support_options";

        case "Previous Menu":
          return "show_audit_options";

        default:
          return "unknown_input";
      }
      await params.injectMessage("Please wait while I redirect you...");
      await params.injectMessage(
        "Incase the link is blocked by your browser, try switching off your vpn or adblocker." +
          "You can directly reach us at info@crea8impact.com or whatsapp us at +919884645176"
      );
      setTimeout(() => {
        window.open(link);
      }, 1000);
      return "repeat";
    },
  },

  // **********************************************************************
  // ************************* Support Options ****************************
  // **********************************************************************
  // This is the support options that the chatbot will show to the user

  show_support_automation: {
    message: "What do you need help with?",
    options: supportAutomationOptions,
    chatDisabled: true,
    path: "process_support_automation",
  },

  process_support_automation: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      switch (params.userInput) { 
        case "Technical Issues":
          await params.injectMessage(
            "Please try clearing your browser cache and cookies. If the issue persists, please contact us through the support options."
          );
          return "show_support_question";
        case "Unable to access dashboard":
          await params.injectMessage(
            "Please try clearing your browser cache and cookies. If the issue persists, please contact us through the support options."
          );
          return "show_support_question";
        case "Billing Questions":
          await params.injectMessage(
            "For billing questions, please contact us through the support options."
          );
          return "show_support_question";
        case "Other":
          await params.injectMessage(
            "Please describe your issue in detail, and we will get back to you as soon as possible."
          );
          return "show_support_question";
        case "Previous Menu":
          return "show_main_options";
        default:
          await params.injectMessage(
            "Sorry, I do not understand your message 😢! If you require further assistance, please select the support option to connect with us"
          );
          return "show_support_question";
      }
    },
  },

  show_support_question: {
    message: "Would you like to connect with us?",
    options: ["Yes", "No", "Main Menu"],
    chatDisabled: true,
    path: "process_support_question",
  },

  process_support_question: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      switch (params.userInput) {
        case "Yes":
          return "show_support_options";
        case "No":
          return "repeat";
        case "Main Menu":
          return "show_main_options";
      }
    },
  },

  show_support_options: {
    message: "Here are our support options:",
    chatDisabled: true,
    options: supportOptions,
    path: "process_support_options",
  },

  process_support_options: {
    transition: { duration: 0 },
    chatDisabled: true,
    path: async (params) => {
      let link = "";
      switch (params.userInput) {
        case "Email Us":
          const subject = encodeURIComponent(
            "Inquiry from Crea8 Impact Chatbot"
          );
          const body = encodeURIComponent(
            "Hello Crea8 Impact Team,\n\nI would like to inquire about your services"
          );
          link = `mailto:info@crea8impact.com?subject=${subject}&body=${body}`;
          break;

        case "Contact Us":
          link = "/contact";
          break;

        case "Whatsapp":
          const whatsappMessage = encodeURIComponent(
            "Hello, I would like to inquire about your services."
          );
          link = `https://wa.me/919884645176?text=${whatsappMessage}`;
          break;

        case "FAQ":
          link = "/services#ask";
          break;

        case "Main Menu":
          return "show_main_options";

        default:
          return "unknown_input";
      }
      await params.injectMessage("Please wait while I redirect you...");
      await params.injectMessage(
        "Incase the link is blocked by your browser, try switching off your vpn or adblocker." +
          "You can directly reach us at info@crea8impact.com or whatsapp us at +919884645176"
      );
      setTimeout(() => {
        window.open(link);
      }, 1000);
      return "repeat";
    },
  },

  // **********************************************************************
  // ************************* Repeat Options ****************************
  // **********************************************************************
  // This is the repeat options that the chatbot will show to the user

  prompt_again: {
    message: "Do you need any other help?",
    chatDisabled: true,
    options: mainOptions,
    path: "process_main_options",
  },
  unknown_input: {
    message:
      "Sorry, I do not understand your message 😢!" + 
      " If you require further assistance, please select the support option to connect with us",
    chatDisabled: true,
    options: mainOptions,
    path: "process_main_options",
  },
  repeat: {
    transition: { duration: 3000 },
    path: "prompt_again",
  },
};
